module.exports = __webpack_public_path__ + "media/images/icons/or_map_pin-e9f77ae32c24a776a246b107b39e4a12.png";